import { ComponentRegistryService } from './component-registry.service';

// Component imports
import { SemTextBoxComponent } from '../../components/controls/sem-text-box/sem-text-box.component';
import { SemHiddenValueComponent } from '../../components/controls/sem-hidden-value/sem-hidden-value.component';
import { SemListingItemsComponent } from '../../components/controls/sem-listing-items/sem-listing-items.component';
import { SemDatePickerComponent } from '../../components/controls/sem-date-picker/sem-date-picker.component';
import { SemSelectComponent } from '../../components/controls/sem-select/sem-select.component';
import { SemTextInputComponent } from '../../components/controls/sem-text-input/sem-text-input.component';
import { SemControlComponent } from '../../components/controls/sem-control/sem-control.component';
import { SemQueryComponent } from '../../components/controls/sem-query/sem-query.component';
import { SemDataGridComponent } from '../../components/controls/sem-data-grid/sem-data-grid.component';
import { SemListComponent } from '../../components/controls/sem-list/sem-list.component';
import { SemTextAreaComponent } from '../../components/controls/sem-text-area/sem-text-area.component';
import { SemRadioButtonComponent } from '../../components/controls/sem-radio-button/sem-radio-button.component';
import { SemSearchComponent } from '../../components/controls/sem-search/sem-search.component';
import { SemDynamicSearchFieldComponent } from '../../components/controls/sem-dynamic-search-field/sem-dynamic-search-field.component';
import { SemCheckBoxComponent } from '../../components/controls/sem-check-box/sem-check-box.component';
import { SemManyToOneControlComponent } from '../../components/controls/sem-many-to-one-control/sem-many-to-one-control.component';
import { SemFileUploadComponent } from '../../components/controls/sem-file-upload/sem-file-upload.component';
import { SemImageViewerComponent } from '../../components/controls/sem-image-viewer/sem-image-viewer.component';
import { SemFacetsComponent } from '../../components/controls/sem-facets/sem-facets.component';
import { SemGraphComponent } from '../../components/controls/sem-graph/sem-graph.component';
import { SemGraphPieComponent } from '../../components/controls/sem-graph-pie/sem-graph-pie.component';
import { SemGraphHistogramComponent } from '../../components/controls/sem-graph-histogram/sem-graph-histogram.component';
import { SemGraphBarComponent } from '../../components/controls/sem-graph-bar/sem-graph-bar.component';
import { SemGraphDonutComponent } from '../../components/controls/sem-graph-donut/sem-graph-donut.component';
import { SemDialogComponent } from '../../components/controls/dialogs/sem-dialog/sem-dialog.component';
import { SemFileExplorerComponent } from '../../components/controls/sem-file-explorer/sem-file-explorer.component';
import { SemGroupRepeaterControlComponent } from '../../components/controls/sem-group-repeater/sem-group-repeater.component';
import { SemDynamicControlComponent } from '../../components/controls/shared/sem-dynamic-control/sem-dynamic-control.component';
import { SemQuickActionsComponent } from '../../components/controls/content-controls/sem-quick-actions/sem-quick-actions.component';
import { SemLastEditedDataComponent } from '../../components/controls/content-controls/sem-last-edited-data/sem-last-edited-data.component';
import { SemAIAssistantComponent } from '../../components/controls/content-controls/sem-ai-assistant/sem-ai-assistant.component';
import { SemActivityTrailComponent } from '../../components/controls/content-controls/sem-activity-trail/sem-activity-trail.component';
import { SemDataQualityComponent } from '../../components/controls/content-controls/sem-data-quality/sem-data-quality.component';
import { SemDailyChallengeComponent } from '../../components/controls/content-controls/sem-daily-challenge/sem-daily-challenge.component';
import { SemSearchBarComponent } from '../../components/controls/sem-search-bar/sem-search-bar.component';
import { SemButtonComponent } from '../../components/controls/sem-button/sem-button.component';
import { SemOneToManyContainerComponent } from '../../components/controls/sem-one-to-many-container/sem-one-to-many-container.component';
import { SemMultiFieldsComponent } from '../../components/controls/sem-multi-fields/sem-multi-fields.component';
import { SemBoundTabControlComponent } from '../../components/controls/sem-bound-tab-control/sem-bound-tab-control.component';
import { SemBoundTabContentComponent } from '../../components/controls/sem-bound-tab-control/sem-bound-tab-content/sem-bound-tab-content.component';
import { SemReportGeneratorComponent } from '../../components/controls/sem-report-generator/sem-report-generator.component';
import { SemMultipleSelectComponent } from '../../components/controls/sem-multiple-select/sem-multiple-select.component';
import { SemBoundLabelComponent } from '../../components/controls/sem-bound-label/sem-bount-label.component';
import { SemProgressBarComponent } from '../../components/controls/sem-progress-bar/sem-progress-bar.component';
import { SemFilePickerComponent } from '../../components/controls/sem-file-picker/sem-file-picker.component';
import { SemTableDataComponent } from '../../components/controls/sem-table-data-control/sem-table-data.component';
import { SemTableGridComponent } from '../../components/controls/charts/sem-table-chart/sem-table-chart.component';
import { SemTimePickerComponent } from '../../components/controls/sem-time-picker/sem-time-picker.component';
import { SemRichTextEditorComponent } from '../../components/controls/sem-rich-text-editor/sem-rich-text-editor.component';
import { SemGeoMapComponent } from '../../components/controls/sem-geo-map/sem-geo-map.component';
import { SemRelatedEntitiesComponent } from '../../components/controls/sem-related-entities/sem-related-entities.component';
import { SemRegexInputComponent } from '../../components/controls/sem-regex-input/sem-regex-input.component';
import { SemLineGraphComponent } from '../../components/controls/charts/graphs/sem-line-graph/sem-line-graph.component';
import { SemLastAddedRecordsComponent } from '../../components/controls/content-controls/sem-last-added-records/sem-last-added-records.component';
import { SemEditModeBtnComponent } from '../../components/controls/sem-edit-mode-btn/sem-edit-mode-btn.component';
import { SemTablePresentationComponent } from '../../components/controls/content-controls/sem-table-presentation/sem-table-presentation.component';
import { SemD3DirectionalGraphComponent } from '../../components/controls/charts/graphs/sem-d3-directional-graph/sem-d3-directional-graph.component';
import { SemChatBotComponent } from '../../components/controls/sem-chat-bot/sem-chat-bot.component';
import { SemGalleryControlComponent } from '../../components/controls/content-controls/sem-gallery-control/sem-gallery-control.component';
import { SemSideContainerComponent } from '../../components/controls/sem-side-container/sem-side-container.component';
import { SemSwitchComponent } from '../../components/controls/sem-switch/sem-switch.component';
import { SemMessengerComponent } from '../../components/controls/sem-messenger/sem-messenger.component';
import { SemHtmlJsComponent } from '../../components/controls/sem-html-js/sem-html-js.component';
import { SemSignControlComponent } from '../../components/controls/sem-sign-control/sem-sign-control.component';
import { SemSnapshotsComponent } from '../../components/controls/sem-snapshots/sem-snapshots.component';
import { SemAjpesInputControl } from '../../components/controls/sem-ajpes-input-control/sem-ajpes-input-control.component';
import { SemCadastralParcelControl } from '../../components/controls/sem-cadastral-parcel-control/sem-cadastral-parcel-control.component';
import { SemIBANComponent } from '../../components/controls/sem-iban/sem-iban.component';
import { SemDocumentEditorComponent } from '../../components/controls/sem-document-editor/sem-document-editor.component';
import { SemTagsInputComponent } from '../../components/controls/sem-tags-input/sem-tags-input.component';
import { SemLoaderComponent } from '../../shared/components/sem-loader/sem-loader.component';
import { SemDynamicComponent } from '../../shared/components/sem-dynamic/sem-dynamic.component';

/**
 * Populates the ComponentRegistryService with all known component selectors.
 * Used as an APP_INITIALIZER in app.module.ts.
 *
 * Phase 2 will use this registry to look up component types by selector
 * when replacing JIT compilation with ViewContainerRef.createComponent().
 */
export function initializeComponentRegistry(registry: ComponentRegistryService): () => void {
  return () => {
    const components: [string, any][] = [
      ['app-sem-text-box', SemTextBoxComponent],
      ['app-sem-hidden-value', SemHiddenValueComponent],
      ['app-sem-listing-items', SemListingItemsComponent],
      ['app-sem-date-picker', SemDatePickerComponent],
      ['app-sem-select', SemSelectComponent],
      ['app-sem-text-input', SemTextInputComponent],
      ['app-sem-control', SemControlComponent],
      ['app-sem-query', SemQueryComponent],
      ['app-sem-data-grid', SemDataGridComponent],
      ['app-sem-list', SemListComponent],
      ['app-sem-text-area', SemTextAreaComponent],
      ['app-sem-radio-button', SemRadioButtonComponent],
      ['app-sem-search', SemSearchComponent],
      ['app-sem-dynamic-search-field', SemDynamicSearchFieldComponent],
      ['app-sem-check-box', SemCheckBoxComponent],
      ['app-sem-many-to-one-control', SemManyToOneControlComponent],
      ['app-sem-file-upload', SemFileUploadComponent],
      ['app-sem-image-viewer', SemImageViewerComponent],
      ['app-sem-facets', SemFacetsComponent],
      ['app-sem-graph', SemGraphComponent],
      ['app-sem-graph-pie', SemGraphPieComponent],
      ['app-sem-graph-histogram', SemGraphHistogramComponent],
      ['app-sem-graph-bar', SemGraphBarComponent],
      ['app-sem-graph-donut', SemGraphDonutComponent],
      ['app-sem-dialog', SemDialogComponent],
      ['app-sem-file-explorer', SemFileExplorerComponent],
      ['app-sem-group-repeater', SemGroupRepeaterControlComponent],
      ['app-sem-dynamic-control', SemDynamicControlComponent],
      ['app-sem-quick-actions', SemQuickActionsComponent],
      ['app-sem-last-edited-data', SemLastEditedDataComponent],
      ['app-sem-ai-assistant', SemAIAssistantComponent],
      ['app-sem-activity-trail', SemActivityTrailComponent],
      ['app-sem-data-quality', SemDataQualityComponent],
      ['app-sem-daily-challenge', SemDailyChallengeComponent],
      ['app-sem-search-bar', SemSearchBarComponent],
      ['app-sem-button', SemButtonComponent],
      ['app-sem-one-to-many-container', SemOneToManyContainerComponent],
      ['app-sem-multi-fields', SemMultiFieldsComponent],
      ['app-sem-bound-tab-control', SemBoundTabControlComponent],
      ['app-sem-bound-tab-content', SemBoundTabContentComponent],
      ['app-sem-report-generator', SemReportGeneratorComponent],
      ['app-sem-multiple-select', SemMultipleSelectComponent],
      ['app-sem-bound-label', SemBoundLabelComponent],
      ['app-sem-progress-bar', SemProgressBarComponent],
      ['app-sem-file-picker', SemFilePickerComponent],
      ['app-sem-table-data', SemTableDataComponent],
      ['app-sem-table-grid', SemTableGridComponent],
      ['app-sem-time-picker', SemTimePickerComponent],
      ['app-sem-rich-text-editor', SemRichTextEditorComponent],
      ['app-sem-geo-map', SemGeoMapComponent],
  ['app-sem-related-entities', SemRelatedEntitiesComponent],
      ['app-sem-regex-input', SemRegexInputComponent],
      ['app-sem-line-graph', SemLineGraphComponent],
      ['app-sem-last-added-records', SemLastAddedRecordsComponent],
      ['app-sem-edit-mode-btn', SemEditModeBtnComponent],
      ['app-sem-table-presentation', SemTablePresentationComponent],
      ['app-sem-d3-directional-graph', SemD3DirectionalGraphComponent],
      ['app-sem-chat-bot', SemChatBotComponent],
      ['app-sem-gallery-control', SemGalleryControlComponent],
      ['app-sem-loader', SemLoaderComponent],
      ['app-sem-side-container', SemSideContainerComponent],
      ['app-sem-switch', SemSwitchComponent],
      ['app-sem-messenger', SemMessengerComponent],
      ['app-sem-html-js', SemHtmlJsComponent],
      ['app-sem-sign-control', SemSignControlComponent],
      ['app-sem-snapshots', SemSnapshotsComponent],
      ['app-sem-ajpes-input-control', SemAjpesInputControl],
      ['app-sem-cadastral-parcel-control', SemCadastralParcelControl],
      ['app-sem-iban', SemIBANComponent],
      ['app-sem-document-editor', SemDocumentEditorComponent],
      ['app-sem-tags-input', SemTagsInputComponent],
      ['app-sem-dynamic', SemDynamicComponent],
    ];

    for (const [selector, type] of components) {
      registry.register(selector, type);
    }
  };
}
